import React from "react";

const AutoFicha = () => {
  return <div>AutoFicha</div>;
};

export default AutoFicha;
